import { useCallback, useRef } from 'react';

import isFunction from 'utils/function';

import useParentalControl from 'screens/PlayerModal/hooks/useParentalControl';

function useStripeParantalControl() {
    const {
        showPinDialog,
        onShowPinDialog,
        onParentalCheckDismiss,
        onParentalControlChecked,
    } = useParentalControl();

    const onParentalControlCheckedCallback = useRef<undefined | (() => void)>(
        undefined,
    );

    const handleSetParentalControlCheckedCallback = useCallback(
        (callback: undefined | (() => void)) => {
            onParentalControlCheckedCallback.current = callback;
        },
        [],
    );

    const handleParentalContolDismiss = useCallback(() => {
        handleSetParentalControlCheckedCallback(undefined);
        onParentalCheckDismiss();
    }, [onParentalCheckDismiss, handleSetParentalControlCheckedCallback]);

    const handleParentalControlChecked = useCallback(() => {
        if (isFunction(onParentalControlCheckedCallback.current)) {
            onParentalControlCheckedCallback.current();
            handleSetParentalControlCheckedCallback(undefined);
        }

        onParentalControlChecked();
    }, [onParentalControlChecked, handleSetParentalControlCheckedCallback]);

    return {
        showPinDialog,
        onShowPinDialog,
        onParentalContolDismiss: handleParentalContolDismiss,
        onParentalControlChecked: handleParentalControlChecked,
        onSetParentalControlCheckedCallback:
            handleSetParentalControlCheckedCallback,
    };
}

export default useStripeParantalControl;
